import React from 'react';
import dynamic from 'next/dynamic';
import { ExchangeFooter } from '@binance/uikit-widget'
import { ThemeProvider, lightTheme } from '@binance/uikit-theme'
import { connect } from 'react-redux';

import withI18n from '../../utils/withI18n';
import { formatNumber } from '../../utils/number';


const RecentMarketBar = dynamic(import('../RecentMarketBar'), {
  ssr: false,
  loading: () => null,
});


type Props = {
  locale: String,
  withRecentMarketBar: Boolean,
  baseConfigs: Object,
  tickers: Object,
  omitFooterTotalUpdate: Boolean,
  isLoggedIn: Boolean,
}

const mapStateToProps = ({
  isLoggedIn,
  tickers,
  baseConfigs
}) => ({
  isLoggedIn,
  baseConfigs,
  tickers,
});

const FooterContainer: React.SFC = ({ origin, locale = 'en', isLoggedIn = false, volumes = [], baseConfigs = {} }) => {

  const footerconfig = React.useMemo(() => {
    const {footer = {}} = baseConfigs
    const {auth = {}, noauth = {}} = footer
    if (isLoggedIn) return auth
    return noauth
  }, [isLoggedIn, baseConfigs])

  return React.useMemo(() => {
    return (
      <ThemeProvider theme={lightTheme}>
        <ExchangeFooter config={footerconfig} volumes={volumes} locale={locale} i18n={baseConfigs.lang || {}}/>
      </ThemeProvider>
    )
  }, [ footerconfig,locale])
}

export default
@withI18n
@connect(mapStateToProps)
class FooterComponent extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getVolumes = () => {
    const { tickers, omitFooterTotalUpdate } = this.props;
    if (omitFooterTotalUpdate) return [];

    const totalVolumes = {};
    Object.values(tickers).forEach((el) => {
      const key = el.pn === 'ALTS' ? el.qa : el.pn;
      if (!totalVolumes[key]) totalVolumes[key] = 0;
      totalVolumes[key] += parseFloat(el.q);
    });

    const list = Object.keys(totalVolumes).map((key) => ({
      market: key,
      total: formatNumber(totalVolumes[key], 2),
    }));

    return list;
  }

  render() {
    const {
      locale, withRecentMarketBar, isLoggedIn, origin = 'https://www.binance.com', baseConfigs = {}
    } = this.props;

    return (
      <>
        { withRecentMarketBar && <RecentMarketBar /> }
          <FooterContainer
            origin={origin}
            baseConfigs={baseConfigs}
            locale={locale}
            isLoggedIn={isLoggedIn}
            volumes={this.getVolumes()}
          />
      </>
    );
  }
}
